export default function NonAffiliationBanner({ compact = false }) {
  return (
    <div className="non-affiliation-banner" role="note">
      <strong>Not affiliated with Oak Lawn Public Library.</strong>{" "}
      {compact
        ? "This is an independently organized parent group."
        : "HS Library Hangout is an independently organized parent group. It is not sponsored, managed, approved, or endorsed by Oak Lawn Public Library. Library staff do not manage events, registrations, supervision, or questions for this group."}
    </div>
  );
}
